var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 11.3337C1.63317 11.3337 1.31939 11.2032 1.0585 10.9423C0.79717 10.681 0.666504 10.367 0.666504 10.0003V8.00033H1.99984V10.0003H9.99984V8.00033H11.3332V10.0003C11.3332 10.367 11.2027 10.681 10.9418 10.9423C10.6805 11.2032 10.3665 11.3337 9.99984 11.3337H1.99984ZM5.99984 8.66699L2.6665 5.33366L3.59984 4.36699L5.33317 6.10033V0.666992H6.6665V6.10033L8.39984 4.36699L9.33317 5.33366L5.99984 8.66699Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b0e512f58b10c8d5f3a970d581ba6875.svg";
export { ForwardRef as ReactComponent };